<script>
    import liquidsInfo from '$lib/json/liquidsInfo.json';
	import ProductInfoBlock from '$lib/components/ProductInfoBlock.svelte';
	import Button from '$lib/components/Button.svelte';
	import CentralBlock from '$lib/components/CentralBlock.svelte';
	import Flavour from '$lib/components/SprayFlavour.svelte';
	import { buyVisible } from '../states';
	import BoilFlavour from '$lib/components/BoilFlavour.svelte';

	// import Image from '$lib/components/Image.svelte';
    const {buy, tackle, weather, guarantor, flavours, useWith} = liquidsInfo;
</script>

<svelte:head>
	<title>Качественные приманки для рыбы и ликвиды для рыбалки</title>
	<meta name="description" property="og:description" content="Ищите приманку для рыбы и ликвиды для рыбалки? У нас вы можете купить высококачественные приманки и ликвиды для рыбалки CSL для успешной ловли рыбы." />
    <meta property="og:title" content="Качественные приманки для рыбы и ликвиды для рыбалки">
    <meta property="og:url" content="https://pro-baits.pro/liquid/">
</svelte:head>

<section class="liquid">
    {#if buy}
        {@const {header, text, image, imageWebp, bg, classList} = buy}
        <ProductInfoBlock
            header={{
                label: header.label,
                fontSize: header.fontSize
            }}
            text={{
                label: text.label,
                fontSize: text.fontSize
            }}
            {image} 
            {imageWebp}
            {bg}
            {classList}
            headerTag="h1"
            bgType="fill"
        >
            <svelte:fragment slot="afterText">
                <div class="btn_wrap">
                    <Button tag="button" on:click={()=>{buyVisible.set(true)}}>Купить</Button>
                </div>
            </svelte:fragment>
        </ProductInfoBlock>
    {/if}
    {#if tackle}
        {@const {header, text, reverse, classList} = tackle}
        <ProductInfoBlock
            header={{
                label: header.label,
                fontSize: header.fontSize
            }}
            text={{
                label: text.label,
                fontSize: text.fontSize
            }}
            {reverse}
            {classList}
            bgType="none"
        >
            <svelte:fragment slot="image">
                <div class="tackle">
                    <img 
                        class="tackle__img" 
                        src="/images/home/tackle.svg" 
                        alt="{header.label} - купить"
                        loading="lazy"
                        draggable="false"
                        decoding="async"
                        aria-hidden="true"
                    >
                    <picture>
                        <source srcset="/images/liquids/webp/liquidUniversal.webp" type="image/webp">
                        <img 
                            class="tackle__spray" 
                            src="/images/liquids/liquidUniversal.png" 
                            alt={header.label}
                            loading="lazy"
                            draggable="false"
                            decoding="async"
                        >
                    </picture>
                </div>
            </svelte:fragment>
        </ProductInfoBlock>
    {/if}
    {#if weather}
        {@const {header, text} = weather}
        <div class="weather container">
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="310" 
                height="400" 
                fill="none"
                viewBox="0 0 310 400"
                class="weather__right"
            >
                <path fill="#14342B" d="M213.83 29.17A45.92 45.92 0 0 1 259.67 75v152.08A79.09 79.09 0 0 1 293 292.17c-.33 42.16-34.83 77.41-76.92 78.58h-2.25a78.55 78.55 0 0 1-55.17-22.42 78.62 78.62 0 0 1-24-56.75A79.16 79.16 0 0 1 168 227V75a45.91 45.91 0 0 1 45.83-45.83ZM143 291.67a70.04 70.04 0 0 0 21.41 50.75 69.88 69.88 0 0 0 51.42 20c37.67-1.09 68.59-32.59 68.84-70.25a70.69 70.69 0 0 0-31.5-59.42 4.13 4.13 0 0 1-1.84-3.5V212.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V187.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V162.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V137.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V112.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V87.5h-12.5a4.13 4.13 0 0 1-4.17-4.17 4.13 4.13 0 0 1 4.17-4.16h12.5V75a37.56 37.56 0 0 0-37.5-37.5 37.56 37.56 0 0 0-37.5 37.5v154.33c0 1.42-.67 2.67-1.83 3.5a70.57 70.57 0 0 0-31.5 58.84Z"/>
                <path fill="#14342B" d="M209.33 258.75v-62.4a4.13 4.13 0 0 1 4.17-4.16 4.13 4.13 0 0 1 4.17 4.16v62.4c18.66 2.08 33.33 17.83 33.33 37.08a37.56 37.56 0 0 1-37.5 37.5 37.56 37.56 0 0 1-37.5-37.5c0-19.25 14.67-35 33.33-37.08ZM213.5 325a29.2 29.2 0 0 0 29.17-29.17 29.2 29.2 0 0 0-29.17-29.16 29.2 29.2 0 0 0-29.17 29.16A29.2 29.2 0 0 0 213.5 325ZM19.43 86.07h9.53l-7.2-14.39a2.45 2.45 0 0 1 1.07-3.25 2.45 2.45 0 0 1 3.26 1.07l8.26 16.57h24.07a16.8 16.8 0 0 1 3.01-8.6l-8.6-8.6-12.3 4.08a2.4 2.4 0 0 1-3.07-1.51 2.38 2.38 0 0 1 1.56-3.06l10.06-3.36L45 60.94a2.4 2.4 0 0 1 0-3.45 2.4 2.4 0 0 1 3.45 0l4.08 4.08 3.36-10.06a2.48 2.48 0 0 1 3.06-1.56 2.48 2.48 0 0 1 1.56 3.07l-4.14 12.4 8.56 8.5c2-1.56 4.28-2.72 6.8-3.3V46.25L55.21 38a2.37 2.37 0 0 1-1.07-3.26 2.37 2.37 0 0 1 3.25-1.07l14.34 7.2v-9.53a2.4 2.4 0 0 1 2.44-2.43 2.4 2.4 0 0 1 2.43 2.43v9.52l14.29-7.19a2.45 2.45 0 0 1 3.25 1.07c.59 1.21.1 2.67-1.07 3.26L76.5 46.26v24.06a16.8 16.8 0 0 1 8.6 3.02l9.24-9.24-4.13-12.35a2.38 2.38 0 0 1 1.55-3.06 2.4 2.4 0 0 1 3.06 1.56l3.36 10.01 4.08-4.13a2.4 2.4 0 0 1 3.45 0 2.4 2.4 0 0 1 0 3.45l-4.13 4.13 10.06 3.36a2.48 2.48 0 0 1 1.56 3.06 2.38 2.38 0 0 1-2.13 1.63 2.4 2.4 0 0 1-.93-.13L97.79 67.5l-9.14 9.19a16.96 16.96 0 0 1 3.6 9.33h24.06l8.26-16.57a2.36 2.36 0 0 1 3.26-1.07 2.37 2.37 0 0 1 1.07 3.25l-7.2 14.4h9.53a2.4 2.4 0 0 1 2.43 2.42 2.4 2.4 0 0 1-2.43 2.43h-9.47l7.19 14.34c.58 1.22.1 2.68-1.07 3.26a2.46 2.46 0 0 1-3.26-1.12l-8.26-16.52h-24.4a17.43 17.43 0 0 1-3.3 6.8l9.18 9.19 12.34-4.13a2.4 2.4 0 0 1 3.07 1.55 2.38 2.38 0 0 1-1.56 3.06l-10.06 3.36 4.13 4.13a2.4 2.4 0 0 1 0 3.45 2.35 2.35 0 0 1-3.4 0l-4.08-4.13-3.36 10.01a2.4 2.4 0 0 1-3.06 1.51 2.47 2.47 0 0 1-1.56-3.06l4.14-12.35L85.2 101a16.68 16.68 0 0 1-8.6 3v24.07l16.57 8.26a2.37 2.37 0 0 1 1.07 3.26 2.37 2.37 0 0 1-3.26 1.07l-14.38-7.2v9.68a2.4 2.4 0 0 1-2.43 2.43 2.4 2.4 0 0 1-2.44-2.43v-9.48l-14.34 7.2a2.46 2.46 0 0 1-2.18-4.38l16.52-8.26v-24.4a17.43 17.43 0 0 1-6.8-3.31l-8.5 8.55 4.12 12.35a2.38 2.38 0 0 1-1.55 3.06 2.4 2.4 0 0 1-3.06-1.5l-3.36-10.07L48.5 117a2.35 2.35 0 0 1-3.4 0 2.4 2.4 0 0 1 0-3.45l4.08-4.09-10.06-3.35a2.47 2.47 0 0 1-1.56-3.06 2.48 2.48 0 0 1 3.06-1.56l12.35 4.13 8.6-8.6a17.02 17.02 0 0 1-2.72-6.13h-24.4l-8.26 16.53a2.4 2.4 0 0 1-2.19 1.36 2.37 2.37 0 0 1-2.14-3.5l7.2-14.34h-9.63A2.4 2.4 0 0 1 17 88.5a2.4 2.4 0 0 1 2.43-2.43Zm55.9 13.32a12.15 12.15 0 1 0 0-24.3 12.15 12.15 0 0 0 0 24.3Z"/>
            </svg>
            <div class="weather__content">
                <h2 class="category__h2 weather__header">
                    {header}
                </h2>
                <p class="weather__text">
                    {text}
                </p>
            </div>
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="310" 
                height="400" 
                fill="none"
                viewBox="0 0 310 400"
                class="weather__left"
            >
                <path fill="#14342B" d="M96.17 29.17A45.92 45.92 0 0 0 50.34 75v152.08A79.09 79.09 0 0 0 17 292.17c.34 42.16 34.84 77.41 76.92 78.58h2.25a78.55 78.55 0 0 0 55.17-22.42 78.62 78.62 0 0 0 24-56.75A79.17 79.17 0 0 0 142 227V75a45.91 45.91 0 0 0-45.83-45.83ZM167 291.67a70.04 70.04 0 0 1-21.41 50.75 69.88 69.88 0 0 1-51.42 20c-37.67-1.09-68.58-32.59-68.83-70.25a70.67 70.67 0 0 1 31.5-59.42 4.13 4.13 0 0 0 1.83-3.5V212.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V187.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V162.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V137.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V112.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V87.5h12.5a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.16h-12.5V75a37.56 37.56 0 0 1 37.5-37.5 37.56 37.56 0 0 1 37.5 37.5v154.33c0 1.42.67 2.67 1.83 3.5a70.57 70.57 0 0 1 31.5 58.84Z"/>
                <path fill="#14342B" d="M100.6 258.75V94.79a4.13 4.13 0 0 0-4.17-4.17 4.13 4.13 0 0 0-4.17 4.17v163.96c-18.66 2.08-33.33 17.83-33.33 37.08a37.56 37.56 0 0 0 37.5 37.5 37.56 37.56 0 0 0 37.5-37.5c0-19.25-14.67-35-33.33-37.08ZM96.43 325a29.2 29.2 0 0 1-29.17-29.17 29.2 29.2 0 0 1 29.17-29.16 29.2 29.2 0 0 1 29.17 29.16A29.2 29.2 0 0 1 96.43 325ZM234.92 53.9a4.13 4.13 0 0 0 4.17-4.16V33.07a4.13 4.13 0 0 0-4.17-4.16 4.13 4.13 0 0 0-4.17 4.16v16.67a4.13 4.13 0 0 0 4.17 4.17Zm0 66.67a4.13 4.13 0 0 0-4.17 4.17v16.67a4.13 4.13 0 0 0 4.17 4.16 4.13 4.13 0 0 0 4.17-4.16v-16.67a4.13 4.13 0 0 0-4.17-4.17Zm-29.5-56.91a4.03 4.03 0 0 0 5.83 0 4.13 4.13 0 0 0 0-5.92L199.5 45.99a4.13 4.13 0 0 0-5.91 0 4.13 4.13 0 0 0 0 5.92l11.83 11.75Zm53.08 47.16a4.13 4.13 0 0 0 0 5.92l11.75 11.75a4.03 4.03 0 0 0 5.84 0 4.13 4.13 0 0 0 0-5.92l-11.75-11.75a4.03 4.03 0 0 0-5.84 0Zm-77.75-19.41h16.67a4.13 4.13 0 0 0 4.17-4.17 4.13 4.13 0 0 0-4.17-4.17h-16.67a4.13 4.13 0 0 0-4.16 4.17 4.13 4.13 0 0 0 4.16 4.17Zm87.5-4.17a4.13 4.13 0 0 0 4.17 4.17h16.67a4.13 4.13 0 0 0 4.16-4.17 4.13 4.13 0 0 0-4.16-4.17h-16.67a4.13 4.13 0 0 0-4.17 4.17Zm-62.83 23.58-11.75 11.75a4.13 4.13 0 0 0 0 5.92 4.02 4.02 0 0 0 5.83 0l11.75-11.75a4.13 4.13 0 0 0 0-5.92 4.03 4.03 0 0 0-5.83 0Zm56-45.91a3.9 3.9 0 0 0 2.92-1.25l11.75-11.75a4.13 4.13 0 0 0 0-5.92 4.13 4.13 0 0 0-5.92 0l-11.75 11.75a4.13 4.13 0 0 0 0 5.92 4.38 4.38 0 0 0 3 1.25Zm-26.5 51.5a29.2 29.2 0 0 0 29.17-29.17 29.2 29.2 0 0 0-29.17-29.17 29.2 29.2 0 0 0-29.17 29.17 29.2 29.2 0 0 0 29.17 29.17Zm0-50a20.83 20.83 0 1 1 0 41.66 20.83 20.83 0 0 1 0-41.66Z"/>
            </svg>
        </div>
    {/if}
    {#if guarantor}
        {@const {header, text, image, imageWebp, reverse} = guarantor}
        <ProductInfoBlock 
            header={{
                label: header,
                fontSize: "inherit"
            }}
            text={{
                label: text,
                fontSize: "inherit"
            }}
            classList="guarantor"
            {reverse}
            {image} 
            {imageWebp}
        />
    {/if}
    {#if useWith}
        {@const {header, text, image, imageWebp, reverse} = useWith}
        <ProductInfoBlock 
            header={{
                label: header,
                fontSize: "inherit"
            }}
            text={{
                label: text,
                fontSize: "inherit"
            }}
            classList="guarantor"
            {reverse}
            {image} 
            {imageWebp}
        />
    {/if}
    {#if flavours}
        {@const {header, text, image, imageWebp, list, classList} = flavours}
        <div class="flavours">
            <ProductInfoBlock 
                header={{
                    label: header,
                    fontSize: "inherit"
                }}
                text={{
                    label: text,
                    fontSize: "inherit"
                }}
                {classList}
                {image} 
                {imageWebp}
            />
            <div class="container">
                <div class="flavours__list">
                    {#each list as {image, imageWebp, name}}
                        <BoilFlavour 
                            {image} 
                            {imageWebp}
                            {name}
                        />
                    {/each}
                </div>
            </div>
        </div>
    {/if}
</section>

<style lang="postcss">
    .flavours{
        margin-top: 3.125rem;
    }
    .btn_wrap{
        width: 21.5rem;
    }
    .flavours__list{
        display: grid;
        max-width: 40rem;
        margin: * auto;
        justify-content: space-between;
        grid-template-columns: repeat(auto-fill, minmax(9.17rem, 10.6rem));
    }
    .liquid :global(.guarantor .category__img){
        width: 18.6rem;
    }

    .weather{
        grid-template-columns: 1fr 1fr;
        display: grid;
        align-items: center;
        justify-content: space-between;
        justify-items: center;
        gap: 0.8rem;
        margin: 2.5rem *;
    }
    .weather__content{
        grid-column: 1/3;
        max-width: 21.4rem;
        order: -1;
    }
    .category__h2{
        font-size: 1.25rem;
    }
    @media (min-width: 540px){
        .weather{
            grid-template-columns: 8rem auto 8rem;
        }
        .weather__content{
            text-align: center;
            order: unset;
            grid-column: unset;
            max-width: 26rem;
        }
    }
    .weather__right,.weather__left{
        width: 7rem;
        height: 11rem;
    }
    @media (min-width: 768px){
        .weather{
            grid-template-columns: 12rem auto 12rem;
        }
        .weather__right,.weather__left{
            width: 12rem;
            height: 16rem;
        }
        .category__h2{
            font-size: 1.65rem;
        }
    }
    .weather__header{
        margin-top: 0;
    }
    .weather__text{
        margin: * * 0;
    }
</style>